import { css } from 'src/ui/style/css'
import { Theme } from 'src/ui/style/Theme'
import { mediaMaxWidth } from 'src/ui/style/mixins/helpers'
import {
    grid,
    horizontalPaddedContent,
    paddedContent,
    verticalChildSpacing
} from 'src/ui/style/mixins/layout'

export const headingStyle = () => (th: Theme) =>
    css`
        text-align: center;
        letter-spacing: 0.1em;
        /*
      Font sizing is better to be here, because if it will be through props of Heading, it requires onresize hook,
      which can slow down application 
    */
        font-size: ${th.fontSize.lg};

        ${mediaMaxWidth(th.screens.md)} {
            font-size: ${th.fontSize.md};
        }

        ${mediaMaxWidth(th.screens.sm)} {
            font-size: ${th.fontSize.sm};
            letter-spacing: 0.2em;
        }
    `

export const textStyle = () => css`
    line-height: 1.4;
`

export const columnContainerStyle = () => (th: Theme) =>
    [
        verticalChildSpacing(th.spacing.lg)(th),
        horizontalPaddedContent()(th),
        css`
            padding-top: 6em;
            padding-bottom: 6em;
            text-align: center;
            align-items: center;
            // For proper positioning of absolute elements like birds
            position: relative;
            // On tablet, sets padding to casual

            ${mediaMaxWidth(th.screens.md)} {
                ${paddedContent()(th)};
            }
        `
    ]

export const columnLayoutStyle = (gapSize?: string) => (th: Theme) =>
    [
        grid({
            minWidth: '8em',
            gap: gapSize || '2em'
        }),
        css`
            width: 100%;
            justify-items: center;
            align-items: start;
            // For positioning step infographic
            position: relative;
            // Set different grid size on tablets

            ${mediaMaxWidth(th.screens.md)} {
                ${grid({
                    minWidth: '15em',
                    gap: gapSize || '2em'
                })}
            }
        `
    ]

export const column2LayoutStyle = (gapSize?: string) => (th: Theme) =>
    [
        grid({
            minWidth: '8em',
            gap: gapSize || '2em'
        }),
        css`
            width: 100%;
            justify-items: center;
            align-items: start;
            // For positioning step infographic
            position: relative;
            // Set different grid size on tablets

            ${mediaMaxWidth(th.screens.md)} {
                ${grid({
                    minWidth: '8em',
                    gap: gapSize || '2em'
                })}
            }
        `
    ]
